class MobileMenu {
  constructor() {
   
    this.menu = document.querySelector(".site-header__menu")
    this.openButton = document.querySelector(".site-header__menu-trigger")
    this.menuIcon = document.querySelector(".site-header__menu-trigger .material-icons")
    this.events()
  }

  events() {
    this.openButton.addEventListener("click", () => this.openMenu())
  }

  openMenu() {
    this.menuIcon.innerHTML = this.menuIcon.innerHTML === 'menu' ? 'close' : 'menu';
    this.openButton.classList.toggle("menu-open")
    this.menu.classList.toggle("site-header__menu--active")
  }
}

export default MobileMenu
